import { AxiosResponse } from 'axios';

import { api } from '../../../http';
import {
  CalendarAssignment,
  DepartmentSchedules,
  EmployeesSchedules
} from '../../../types/interfaces';
import { ApiResponse } from '../interfaces';

export const ScheduleDepartmentService = {
  getDiagram(
    id: number,
    params: {
      date?: string;
      name?: string;
      personnelNumber?: string;
      sortBy?: string;
      sortDirection?: string;
      filterEmployeesByAvailableToday?: boolean;
      excludeLongAbsences?: boolean;
      todayShiftOnly?: boolean;
    }
  ): Promise<AxiosResponse<ApiResponse<CalendarAssignment>>> {
    return api.get<ApiResponse<CalendarAssignment>>(
      `ScheduleDepartment/${id}/calendar`,
      {
        params: {
          ...params,
          date: params.date ? params.date : undefined
        }
      }
    );
  },

  getDepartmentsSchedule(
    departmentId: number,
    date: string
  ): Promise<AxiosResponse<ApiResponse<DepartmentSchedules>>> {
    return api.get<ApiResponse<DepartmentSchedules>>(
      `ScheduleDepartment/${departmentId}`,
      {
        params: { date }
      }
    );
  },

  getPersonsSchedules(
    departmentId: number,
    date: string
  ): Promise<AxiosResponse<ApiResponse<EmployeesSchedules>>> {
    return api.get<ApiResponse<EmployeesSchedules>>(
      `ScheduleDepartment/${departmentId}/person`,
      { params: { date } }
    );
  }
};
